import Cookie from "js-cookie"

import { SentryWrapper } from "../Sentry/SentryWrapper"
import { CURRENCY } from "../../constants"

const cookieName = "deduplication_cookie"

export function getBrokerName() {
    const cookieValue = Cookie.get(cookieName)
    if (!cookieValue) return "na"
    if (cookieValue === "admitad") return "adm"
    return cookieValue
}

const MAX_ATTEMPTS = 5
const INTERVAL = 500

export function waitAdmitad(onReady) {
    let attempt = 0
    return function check() {
        ++attempt
        if (window.ADMITAD) {
            return onReady()
        } else if (attempt <= MAX_ATTEMPTS) {
            window.setTimeout(() => check(), INTERVAL)
        }
    }
}

export function reportInvoice(bookingHash, psyHashId, serviceTypeId, price) {
    const Product = {
        productID: `${psyHashId}-${serviceTypeId}`,
        category: "1",
        price,
        priceCurrency: CURRENCY.RUB,
    }
    const order = {
        orderNumber: bookingHash,
        orderedItem: [
            {
                Product,
                orderQuantity: 1,
                additionalType: "sale",
            },
        ],
    }
    const ADMITAD = window.ADMITAD || {
        Invoice: {},
        Tracking: {
            processPositions() {
                SentryWrapper.getInstance().captureException(
                    `Admitad isn't ready after ${MAX_ATTEMPTS * INTERVAL}ms`,
                    {}
                )
            },
        },
    }
    ADMITAD.Invoice = {
        ...ADMITAD.Invoice,
        broker: getBrokerName(),
        category: "1",
        referencesOrder: [order],
    }
    ADMITAD.Tracking.processPositions()
}
